import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "@/features/auth/authSlice";
import debtorsReducer from "@/features/debtors/store/debtorsSlice";
import casesReducer from "@/features/cases/store/casesSlice";
import paymentsReducer from "@/features/payments/store/paymentsSlice";
import disputesReducer from "@/features/disputes/store/disputesSlice";
import agentsReducer from "@/features/agents/store/agentsSlice";
import banksReducer from "@/features/settings/store/banksSlice";
import targetsReducer from "@/features/settings/store/targetsSlice";
import permissionsReducer from "@/features/settings/store/permissionsSlice";
import employeesReducer from "@/features/hrm/store/employeesSlice";
import attendanceReducer from "@/features/hrm/store/attendanceSlice";

const appReducer = combineReducers({
  auth: authReducer,
  debtors: debtorsReducer,
  cases: casesReducer,
  payments: paymentsReducer,
  disputes: disputesReducer,
  agents: agentsReducer,
  banks: banksReducer,
  targets: targetsReducer,
  permissions: permissionsReducer,
  employees: employeesReducer,
  attendance: attendanceReducer,
});

// On logout, reset every slice to its initial state so no user's data leaks
// into the next session (important for team-leader data isolation).
const rootReducer = (state: Parameters<typeof appReducer>[0], action: any) => {
  if (action.type === "auth/logout") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({ reducer: rootReducer });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
